const skills = [
  "HTML",
  "CSS",
  "SASS",
  "TAILWIND-CSS",
  "MATERIAL-UI",
  "SHADCN-UI",
  "JAVASCRIPT",
  "REACT.JS",
  "NEXT.JS",
  "ASTRO.JS",
  "SVELTE",
  "NODE.JS",
  "PHP",
  "MYSQL",
  "WEB3.JS",
];

export default skills;